/* GS2 cart guard (Charlie's cart design 2026-09-23).
 *
 * Gift subscriptions ride the cart as a gift line (_gs2_token) plus optional
 * paid add-on lines bound to it (_gs2_attach teaware / _gs2_extra 5th tea).
 * Two invariants the native cart can't enforce on its own:
 *   1. no orphans - removing a gift must also remove its paid add-on lines
 *   2. gift lines are qty 1 - browser back/forward can replay the /cart/add
 *      chain and silently merge a gift line to qty 2 (a double charge)
 *
 * Sweeps on page load and after every ajax cart change (the theme fires
 * cart:updated). Fixes are applied server-side via /cart/update.js, so even
 * if the visible cart is briefly stale, checkout always sees the corrected
 * cart. On the cart page we reload to re-render.
 *
 * It also publishes the cart's current gift tokens in a domain-wide cookie
 * (gs2_cart_tokens) so /gs2 on app.tearunners.com — which cannot read this
 * cart cross-origin — knows which gifts are REALLY in the cart. Each entry
 * is "token" or "token:SKU1|SKU2" (the gift's paid-teaware SKUs, which the
 * app's Edit links need but the gift record doesn't store), entries joined
 * by commas. Written on every sweep, including as the empty string when no
 * gifts remain.
 */
(function () {
  var busy = false;

  function publishTokens(entries) {
    try {
      document.cookie =
        'gs2_cart_tokens=' + encodeURIComponent(entries.join(',')) +
        '; domain=.tearunners.com; path=/; max-age=1209600; SameSite=Lax';
    } catch (err) { /* preview domains can't set it — harmless */ }
  }

  function sweep() {
    if (busy) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Per gift token, the WINNING revision is the newest _gs2_rev among
        // its gift lines (an edit-save just ADDS a fresh revision; this sweep
        // deletes the superseded one — saves never remove lines themselves,
        // so they can't crash on stale line keys). Missing rev counts as 0.
        var winners = {};
        cart.items.forEach(function (item) {
          var p = item.properties || {};
          if (!p._gs2_token) return;
          var rev = Number(p._gs2_rev) || 0;
          if (winners[p._gs2_token] === undefined || rev > winners[p._gs2_token]) {
            winners[p._gs2_token] = rev;
          }
        });
        var updates = {};
        var attachSkus = {};
        cart.items.forEach(function (item) {
          var p = item.properties || {};
          var rev = Number(p._gs2_rev) || 0;
          if (p._gs2_token) {
            if (winners[p._gs2_token] !== rev) {
              updates[item.key] = 0; // superseded revision of the gift line
            } else if (item.quantity > 1) {
              updates[item.key] = 1; // replayed add merged into qty > 1
            }
            return;
          }
          var bind = p._gs2_attach || p._gs2_extra;
          if (bind && winners[bind] !== rev) {
            updates[item.key] = 0; // orphaned, or belongs to an old revision
            return;
          }
          if (p._gs2_attach && item.sku) {
            attachSkus[bind] = (attachSkus[bind] || []).concat(item.sku);
          }
        });
        publishTokens(Object.keys(winners).map(function (token) {
          return attachSkus[token] ? token + ':' + attachSkus[token].join('|') : token;
        }));
        if (Object.keys(updates).length === 0) return;
        busy = true;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function () {
            busy = false;
            if (window.location.pathname === '/cart') {
              window.location.reload();
            }
          })
          .catch(function () { busy = false; });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }
  document.addEventListener('cart:updated', function () { sweep(); });
})();
